import dialog from '@/mixins/dialog'

export default {
    mixins: [dialog],

    props: {
        autoShow: { type: Boolean, default: true },
    },
}